export default __webpack_public_path__ + "static/media/template_grid.b2a77514.png";